// stateSlice.js
import { createSlice } from "@reduxjs/toolkit";

// define interface for your state
export interface State {
  week: number;
  year: number;
  minYear: number;
  sundays: any[];
  navigate: any;
  loading: boolean;
  grabbedData: boolean;
  thoughts: any[];
  sundaysWithThoughts: any[][];
  setSundaysWithThoughts: (sundaysWithThoughts: any[][]) => void;
  view: string;
  themes: any[];
}

const stateSlice = createSlice({
  name: "state",
  initialState: {
    week: 1,
    year: new Date().getFullYear(),
    minYear: 2023,
    sundays: [],
    navigate: null,
    loading: true,
    grabbedData: false,
    thoughts: [],
    view: "calendar",
    themes: [],
    sundaysWithThoughts: [],
    setSundaysWithThoughts: () => {},
  },
  reducers: {
    setWeek: (state, action) => {
      state.week = action.payload;
    },
    setYear: (state, action) => {
      state.year = action.payload;
    },
    setSundays: (state, action) => {
      state.sundays = action.payload;
    },
    setNavigate: (state, action) => {
      state.navigate = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setGrabbedData: (state, action) => {
      state.grabbedData = action.payload;
    },
    setThoughts: (state, action) => {
      state.thoughts = action.payload;
    },
    setView: (state, action) => {
      state.view = action.payload;
    },
    setThemes: (state, action) => {
      state.themes = action.payload;
    },
    setSundaysWithThoughts: (state, action) => {
      state.sundaysWithThoughts = action.payload;
    },
  },
});

export const {
  setWeek,
  setYear,
  setSundays,
  setNavigate,
  setLoading,
  setGrabbedData,
  setThoughts,
  setView,
  setThemes,
} = stateSlice.actions;
export default stateSlice.reducer;
